import classNames from 'classnames';
import { Button } from 'components/atoms/Button';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import useMutation from 'hooks/react-query/useMutation';

import { ConfirmProps } from './helpers';

const Confirm: FC<ConfirmProps> = (props) => {
  const {
    onConfirm,
    onDecline,
    message,
    okText,
    cancelText,
    okTracingEvent,
    cancelTracingEvent,
    onDone,
    className,
    buttonsWrapperClassName,
    buttonClassName,
    color,
    okButtonClassName,
  } = props;
  const { t } = useTranslation();
  const onConfirmResult = useMutation(() => Promise.resolve().then(onConfirm), {
    onSuccess: onDone,
  });
  const onDeclineResult = useMutation(() => Promise.resolve().then(onDecline), {
    onSuccess: onDone,
  });

  return (
    <div className={classNames(className)}>
      <div className="whitespace-pre-line mb-6 first-letter:capitalize">
        {message}
      </div>
      <div className={classNames('flex gap-2', buttonsWrapperClassName)}>
        <Button
          structure="secondary"
          loading={onDeclineResult.isLoading}
          onClick={() => onDeclineResult.mutate()}
          className={classNames('min-w-[100px]', buttonClassName)}
          color={color}
          tracingEvent={cancelTracingEvent}
        >
          {cancelText || <span className="capitalize">{t('cancel')}</span>}
        </Button>
        <Button
          loading={onConfirmResult.isLoading}
          onClick={() => onConfirmResult.mutate()}
          className={classNames(
            'min-w-[100px]',
            buttonClassName,
            okButtonClassName,
          )}
          color={color}
          tracingEvent={okTracingEvent}
        >
          {okText || <span className="capitalize">{t('continue')}</span>}
        </Button>
      </div>
    </div>
  );
};

export default Confirm;
